<script>
  export let letter;
  export let alphabet;
  export let select;
  export let currentIndex;

  let color = `var(--color-${letter.cat})`;
  let duration = letter.end - letter.start;
  let isSelected = false;
  let style = "";

  $: isSelected = currentIndex === letter.index;
  $: style = `grid-area: ${letter.area};
    transition: all ease-in-out ${duration}s;
    background-color: ${isSelected ? "white" : color};
    transform: scale(${isSelected ? 1.2 : 1});
    opacity: ${isSelected ? 1 : 0.7};
  `;
</script>

<style>
  button {
    margin: 0;
    padding: 0;
    font-size: 4vh;
    font-weight: 700;
    border-radius: 50%;
    will-change: transform, opacity;
  }
</style>

<button {style} on:click={() => select(letter.index)}>
   {letter[alphabet]}
</button>
